module.exports = __webpack_public_path__ + "resource/img/template.d59bfd34.png";